import React, { Component } from "react";
import ErrorFallback from "../components/errorFallback";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by Error Boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Instead of replacing the entire UI, we just overlay the Snackbar
      return (
        <>
          {this.props.children} {/* Keep the last screen visible */}
          <ErrorFallback /> {/* Overlay Snackbar */}
        </>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
